<div class="signIn-section">
  <div class="signIn-container">
    <div class="signIn-upper-section">
      <span class="signIn-title-text">Register to dp</span>
      <div class="signInin-field-section">
        <div>
          <span class="input-level-text-para"
            >In order to successfully activate your credentials, you need to
            verify your email and phone number.</span
          >
        </div>
        <form [formGroup]="signInFormVerification">
          <!--2 input boxex-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Phone OTP</span>
                <input
                  type="text"
                  class="input-field dp-input-control"
                  placeholder="Enter OTP sent on phone"
                  formControlName="phoneOtp"
                />
                <!-- <span 
  (click)="onResend()"
  [style.pointerEvents]="isSpanDisabled ? 'none' : 'auto'"
  [style.color]="isSpanDisabled ? '#ccc' : 'initial'"
  [style.cursor]="isSpanDisabled ? 'not-allowed' : 'pointer'"
>
  Resend
</span> -->
                @if (!isSpanDisabledForMobile) {
                <span class="resend-text" (click)="onResendForMobile()">
                  Resend
                </span>
                } @if (isSpanDisabledForMobile) {
                <span class="resend-countdown-text">
                  Resend in {{ countdownForMobile }}
                </span>
                }

                <!-- @if(){
                <span class="resend-text"
                  >Resend in {{ countdown }} seconds</span
                >

                } -->

                <!-- @if( signInFormVerification.get('phoneOtp')?.invalid &&
                signInFormVerification.get('phoneOtp')?.touched){
              <span class="resend-text">Resend</span>
              } -->
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="input-field-container">
                <span class="input-level-text">Email OTP</span>
                <input
                  type="text"
                  class="input-field dp-input-control"
                  placeholder="Enter OTP sent on Email"
                  formControlName="emailOtp"
                />
                @if (!isSpanDisabledForEmail) {
                <span class="resend-text" (click)="onResendForEmail()">
                  Resend
                </span>
                } @if (isSpanDisabledForEmail) {
                <span class="resend-countdown-text">
                  Resend in {{ countdownForEmail }}
                </span>
                }
              </div>
            </div>
          </div>

          <button
            class="signIn-button dp-primary-btn"
            type="submit"
            (click)="opensuccessdialog()"
          >
            Verify codes
          </button>

          <!-- <div class="input-field-container">
              <span class="input-level-text">Password*</span>
              <div class="password-container">
                <input
                  [type]="passwordVisible ? 'text' : 'password'"
                  class="input-field dp-input-control"
                  placeholder="Enter your password"
                  formControlName="password"
                  (keyup)="onInputBlur('password')"
                  (blur)="onInputBlur('password')"
                />
                @if (loginForm.get('password')?.value) {
                <div
                  class="password-icon"
                  [ngStyle]="{
                    'background-image': passwordVisible
                      ? 'var(' + visibilityOnIcon + ')'
                      : 'var(' + visibilityOffIcon + ')'
                  }"
                  (click)="togglePasswordVisibility()"
                ></div>
                }
              </div>
              @if (passwordInvalid) {
              <span class="error-message"> Enter a valid password </span>
              }
            </div>-->
        </form>
      </div>
    </div>
    <div class="footer-section">
      <div class="registration-ask-text">Already registered with DP Works?</div>
      <a class="registration-now-text" (click)="goToLogin()">Login now</a>
    </div>
  </div>
</div>
